import { render, staticRenderFns } from "./ManagerMessage.vue?vue&type=template&id=3703a502&scoped=true&"
import script from "./ManagerMessage.vue?vue&type=script&lang=js&"
export * from "./ManagerMessage.vue?vue&type=script&lang=js&"
import style0 from "./ManagerMessage.vue?vue&type=style&index=0&id=3703a502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3703a502",
  null
  
)

export default component.exports